var render = function render(){var _vm=this,_c=_vm._self._c;return (_vm.showPaymentDate)?_c('div',{staticClass:"pdo"},[(_vm.hasIcon)?_c('img',{attrs:{"src":require("@/assets/img/icons/calendar.svg"),"alt":"","tabindex":"-1"}}):_vm._e(),(_vm.isPixOpenFinancePayment)?_c('p',{domProps:{"textContent":_vm._s(_vm.$ml.get('pixOpenFinancePayToday') + ' (' + _vm.pixOpenFinancePaymentDate + ')')}}):_vm._e()]):_vm._e()
}
var staticRenderFns = []

export { render, staticRenderFns }